import React, { useState, useEffect, useContext } from 'react';
import Instance from '../../../Services/Instance';
import config from '../../../Services/config';
import { X } from 'lucide-react';
import { toast } from "react-toastify";
import loadingGif from "../../../Assets/Imgs/loading2.gif";
import { DataContext } from '../../../Services/DataContext';
import "../../../Assets/Styles/NetflixList.css"


const UpdatePopup = ({ onClose, row , type }) => {
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { refreshData } = useContext(DataContext);

    const [license, setLicense] = useState({
        key: '',
        name: '',
        productTypeSmart: '',
        number: '',
        orderNumber: '',
        policy: '',
        productCategory: '',
        productName: '',
        status: '',
        userEmail: '',
        userName: '',
        userNumberPhone: '',
    });

    const id = row._id;

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const result = await Instance.get(`${config.api_url}/show-license/${id}`);
                setLicense(result.data.license);
            } catch (error) {
                setError('Erreur lors de la récupération de cette licence');
                console.log(error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            if(type === "Renewal"){
                await Instance.put(`${config.api_url}/update-license-netflix/${id}`, license);
            }else{
                await Instance.put(`${config.api_url}/update-license/${id}`, license);
            }
            onClose();
            toast.success("Licence modifiée avec succès !");
            refreshData();
        } catch (error) {
            console.error('Erreur lors de la mise à jour de la licence :', error);
            setError(error);
            toast.error("Erreur lors de la mise à jour !");
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        setLicense({ ...license, [e.target.name]: e.target.value });
    };

    if (loading) {
        return (
            <div className="netflix-overlay">
                <div className="netflix-loader-container">
                    <p className="netflix-loader-text">Chargement des Informations...</p>
                    <img className="netflix-loader-image" src={loadingGif} alt="Chargement" />
                </div>
            </div>
        );
    }

    return (
        <div className="netflix-overlay">
            <div className="netflix-popup">
                <div className="netflix-popup-header">
                    <div onClick={onClose} className="netflix-popup-close">
                        <X className="netflix-popup-close-icon" />
                    </div>
                </div>
                <h2 className="netflix-popup-title">Modifier la licence</h2>
                <form onSubmit={handleSubmit} className='netflix-popup-form-update-popup'>
                    <div className="netflix-popup-form">
                        <div className="netflix-popup-form-item">
                            <label>Nom</label>
                            <input className="netflix-popup-input" value={license.name} name="name" type="text" onChange={handleInputChange} />
                        </div>
                        <div className="netflix-popup-form-item">
                            <label>Nombre</label>
                            <input className="netflix-popup-input" value={license.number} name="number" type="text" onChange={handleInputChange} required />
                        </div>
                        <div className="netflix-popup-form-item">
                            <label>Politique</label>
                            <input className="netflix-popup-input" value={license.policy} name="policy" type="text" onChange={handleInputChange} required />
                        </div>
                        <div className="netflix-popup-form-item">
                            <label>Statut</label>
                            <input className="netflix-popup-input" value={license.status} name="status" type="text" onChange={handleInputChange} required />
                        </div>
                        {license.productTypeSmart && (
                            <div className="netflix-popup-form-item">
                                <label>Netflix type:</label>
                                <select value={license.productTypeSmart} name="productTypeSmart" onChange={handleInputChange}>
                                    <option value="">Sélectionner un type</option>
                                    <option value="Smart TV">Smart TV</option>
                                    <option value="Phone/Pc">Phone/Pc</option>
                                </select>
                            </div>
                        )}
                        <div className="netflix-popup-form-item">
                            <label>Compte</label>
                            <textarea className="netflix-popup-input netflix-popup-input-textarea " name="key" value={license.key} onChange={handleInputChange} required />
                        </div>
                    </div>

                    <div className="netflix-form-submit">
                        <button type="submit" className="netflix-popup-submit-btn">
                            Modifier
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UpdatePopup;
